import { Injectable } from '@angular/core';
import { openDB, IDBPDatabase } from 'idb';

const DB_NAME = 'AumicoProjectNavigationDB';
const STORE_NAME = 'LastVisitedImportTab';
const DB_VERSION = 1;

@Injectable({
    providedIn: 'root',
})
export class LastVisitedImportTabService {
    private dbPromise: Promise<IDBPDatabase>;

    constructor() {
        this.dbPromise = openDB(DB_NAME, DB_VERSION, {
            upgrade(db) {
                if (!db.objectStoreNames.contains(STORE_NAME)) {
                    db.createObjectStore(STORE_NAME);
                }
            },
        });
    }

    async setLastVisitedTab(projectId: string, tab: string): Promise<void> {
        const db = await this.dbPromise;
        await db.put(STORE_NAME, tab, projectId);
    }

    async getLastVisitedTab(projectId: string): Promise<string | undefined> {
        const db = await this.dbPromise;
        return db.get(STORE_NAME, projectId);
    }
}
